module.exports = __webpack_public_path__ + "img/detailHf.86a21aa5.png";